import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export interface ReadOnlyTextFieldClasses {
	/** styles applied to the root element */
	root: string;
	label: string;
	value: string;

	disabled: string;
	limitHeightToContainer: string;
	pseudoValue: string;
	wrapLabel: string;
}

export function getReadOnlyTextFieldUtilityClass(slot: string) {
	return generateUtilityClass('ReadOnlyTextField', slot);
}

export const readOnlyTextFieldClasses = generateUtilityClasses<
	keyof ReadOnlyTextFieldClasses
>('ReadOnlyTextField', [
	'root',
	'disabled',
	'label',
	'limitHeightToContainer',
	'pseudoValue',
	'value',
	'wrapLabel',
]);
export default readOnlyTextFieldClasses;
